import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";
import { Reveal } from "../lib/motion";
import { FAQ } from "../data/site";

export const Faq = () => {
  return (
    <section id="faq" className="relative py-[clamp(64px,9vw,120px)] bg-surface/30 border-y border-white/10" data-testid="faq-section">
      <div className="container-pm grid lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-16">
        <Reveal>
          <p className="eyebrow mb-4">Najczęstsze pytania</p>
          <h2 className="font-display font-semibold text-white text-[clamp(30px,4vw,54px)] leading-[1.04] tracking-[-0.035em]">
            Masz pytania? <span className="text-coral">Mamy odpowiedzi.</span>
          </h2>
          <p className="mt-5 text-white/60 max-w-[36ch]">
            Wszystko, co warto wiedzieć zanim zaczniemy współpracę. Reszta — na dyskretnej rozmowie.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-lg text-white hover:text-coral hover:no-underline py-5"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/65 text-base leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
